import React from 'react'
import Sectiontitle from '../section-title'
import { useSiteSettings, resolveMediaUrl } from '../../siteSettings';
import './style.css'

const Couple = (props) => {
    const settings = useSiteSettings();
    const section = settings.coupleSection;
    if (!section || !section.title) return null;
    const person1 = section.person1 || {};
    const person2 = section.person2 || {};
    return(
        <div id="couple" className={`about-wrap ${props.couple}`}>
            <div className="couple-area section-padding">
                <Sectiontitle section={section.title}/>
                <div className="container">
                    <div className="couple-wrap">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 couple-single">
                                <div className="couple-wrap couple-wrap-2">
                                    <div className="couple-img">
                                        <img src={resolveMediaUrl(person1.image)} alt="thumb"/>
                                    </div>
                                    <div className="couple-text">
                                        <div className="couple-content">
                                            <h3>{person1.name}</h3>
                                            <p>{person1.description}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 couple-single">
                                <div className="couple-wrap couple-wrap-3">
                                    <div className="couple-img couple-img-2">
                                        <img src={resolveMediaUrl(person2.image)} alt="thumb"/>
                                    </div>
                                    <div className="couple-text">
                                        <div className="couple-content">
                                            <h3>{person2.name}</h3>
                                            <p>{person2.description}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             
        </div>
        
    )
}

export default Couple;
